const sorter = {
  // "sunday": 0, // << if sunday is first day of week
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
  sunday: 7,
};
export function sortByDayString(data, property) {
  let sortedData = [...data];
  sortedData.sort(function sortByDay(a, b) {
    let day1 = a[property].toLowerCase();
    let day2 = b[property].toLowerCase();
    return sorter[day1] - sorter[day2];
  });
  return sortedData;
}
